import { Typography, makeStyles} from "@material-ui/core";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { assets } from "../assets/assets";
import {projects} from "../data"

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
    backgroundColor: "transparent",
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    height: 20,
    "&$expanded": {
      minHeight: 40,
    },
    "&:hover,&:focus": {
      backgroundColor: "rgb(150,0,200)",
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    backgroundColor: "rgba(0, 0, 0, .3)",
    padding: theme.spacing(2),
    color: "white",
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles((theme) => ({
    subtitle: {
      fontWeight: "500",
      color: "white",
    },
    accordion: {
      display: "flex",
      flexDirection: "column",
    },
  }));

const styles = {
    subtitle: {
      height: "100%",
      position: "relative",
      overflowY: "auto",
    },
  
    herramientas: {
      marginLeft: "10px",
    },
  };

const ProjectList = ({setProject}) => {
    const classes = useStyles()
    const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
    return (
        <div style={styles.subtitle}>
          {projects.map((project, index) => (
          <Accordion
            expanded={expanded === index}
            onChange={handleChange(index)}
          >
            <AccordionSummary
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              onClick={() => setProject(project.name.toLowerCase().replace(/\s/,""))}
            >
              <Typography className={classes.subtitle} variant="h5">
                {project.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordion}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>
                  <b>Type:</b> {project.type}
                </Typography>
                <a
                  href={project.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{ border: "none" }}
                >
                  <img alt="" style={{ height: "20px" }} src={assets.link} />
                </a>
              </div>
              <Typography>
                <b>Functions:</b> {project.functions}
              </Typography>
              <Typography style={{ display: "flex", alignItems: "center" }}>
                <b>Tools:</b>{" "}
                <span style={styles.herramientas}>
                  {project.tools.map((icon) => (
                    <img
                      alt=""
                      style={{ height: "20px", paddingRight: "10px" }}
                      src={assets[icon]}
                    />
                  ))}
                </span>
              </Typography>
            </AccordionDetails>
          </Accordion>))}
        </div>
    )
}

export default ProjectList
